__webpack_require__.p = "/reactdigitalgarden/apps/simple-calculator/";